//  [type=number]なinputをカンマ付きの値で表示できるようにするクラス。
//
//  使い方:
//
//    const element = document.querySelector("#number-input")
//    new CommaSeparatedValue(element).initialize()
//
//  注意:
//
//    z-indexを調整することで表示用のinputと入力用のinputのどちらを表示するかを変えています。
//    app/assets/stylesheets/trestle/_custom.cssにstyleの設定あり。

export default class {
  constructor (target) {
    this.target = target
  }

  // 処理が実行されたかどうかの判定に使うクラス。
  // スタイルを当てて見た目を調整するならこれらのクラスを用いる。
  static classes () {
    return {
      input: 'm-comma-separated-input__input',
      overlap: 'm-comma-separated-input__overlap',
      container: 'm-comma-separated-input__container',
    }
  }

  // value をカンマ付きの文字列に変換する処理。
  // Number.prototype.toLocaleString()の実装に完全に依存しているのでちょっと怖い。
  static commaSeparatedValue (value) {
    const parsedValue = parseFloat(value)

    return isNaN(parsedValue) ? '' : parsedValue.toLocaleString()
  }

  initialize () {
    if (this.isInitialized()) {
      return
    }

    this.parseOptions()
    this.setNode()
    this.addClass()
    this.setHTMLAttributes()
    this.addEventListener()
    this.syncValue()
  }

  isInitialized () {
    const classes = Object.values(this.constructor.classes())
    return classes.some((klass) => this.target.classList.contains(klass))
  }

  parseOptions () {
    const dataset = this.target.dataset
    const options = {}

    if (dataset.commaSeparatedInputType === 'decimal') {
      options.inputMode = 'decimal'
      options.step = dataset.commaSeparatedInputStep || 0.01
    } else {
      options.inputMode = 'numeric'
      options.step = 1
    }

    this.options = options
  }

  setNode () {
    this.container = this.target.parentElement
    this.overlap = this.target.cloneNode()

    this.container.appendChild(this.overlap)
  }

  addClass () {
    const classes = this.constructor.classes()

    this.target.classList.add(classes.input)
    this.overlap.classList.add(classes.overlap)
    this.container.classList.add(classes.container)
  }

  setHTMLAttributes () {
    // 数値以外の値がくることをなるべく防ぐ。
    this.target.type = 'number'
    this.target.inputMode = this.options.inputMode

    // overlap用のidに書き換える
    this.overlap.id = `${this.target.id}_overlap`

    // カンマ付きの値を入力するために[type=number]を解除する。
    this.overlap.type = 'text'

    // 表示のためのinputはフォームを送信するときに値に含まれないようにする。
    this.overlap.removeAttribute('name')

    // 表示のためのinputはtabでフォーカスがあたってはならない。
    this.overlap.tabIndex = '-1'

    // inputModeに応じてstepを指定。
    this.target.step = this.options.step
  }

  syncValue () {
    this.formatTargetValue()
    this.overlap.value = this.constructor.commaSeparatedValue(this.target.value)
  }

  // input[type=number]を指定していても全角文字を入力されてしまうことがある。
  // 数値以外の値を受け付けないための対応。
  formatTargetValue () {
    const NUMBER_REGEXP = /^-?\d+(\.\d+)?$/

    if (!NUMBER_REGEXP.test(this.target.value)) {
      this.target.value = null
    }
  }

  addEventListener () {
    this.target.addEventListener('blur', this.syncValue.bind(this))
    this.target.addEventListener('change', this.syncValue.bind(this))
  }
}
